import { config } from 'config'
import { useLocale } from 'hooks/index'

const useSupportUrl = () => {
  const locale = useLocale().split(/_|-/)[0]
  return config.SUPPORT_URL[locale] || config.SUPPORT_URL['en']
}

export default useSupportUrl
